import sys from './globalFunction'
import { serverUrl, serverPrefixUrl } from '../config'
import tremApi from './tremApi'
import S from './tremSession'
import Cookies from 'js-cookie'
import G from './globalFunction'
import * as R from 'ramda'
import { setSessionStartDt } from '../context/globalContext'

const getPublicAddress = async (URL, PARAMS) => {
    var param = null

    if (R.isNil(PARAMS)) {
        param = {
            URL: URL,
        }
    } else {
        param = {
            URL: URL,
            PARAMS: PARAMS,
        }
    }

    await tremApi('/public/address/access/output', param)
        .then(obj => {
            let SUCESS = obj.SUCESS
            let MESSAGE = obj.MESSAGE
            let FULL_PATH = obj.FULL_PATH

            if (SUCESS == 'S') {
                let host = window.location.hostname // 웹 호스트의 도메인 네임 반환
                let protocol = window.location.protocol // 사용하는 웹 프로토콜 반환 (http:// 혹은 https://)
                let port = window.location.port // 사용하는 웹 포트 반환 (8080)
                let PATH = ''

                if (host === 'localhost' || host === '127.0.0.1') {
                    PATH = protocol + '//' + host + ':' + port + FULL_PATH
                } else {
                    PATH = protocol + '//' + host + FULL_PATH
                }

                navigator.clipboard.writeText(PATH)

                sys.alert(G.t('trem.lang.home.0935'), null)
                // "주소가 복사 되었습니다. 원하는 곳에 붙여 넣기를 해주세요."
            } else {
                sys.alert(MESSAGE, null)
            }
        })
        .catch(err => {
            sys.alert(err, G.t('trem.lang.home.0836')) /* 오류발생 */
        })
}

const getNewPublicAddress = async (target, URL, PARAMS) => {
    var param = null

    if (R.isNil(PARAMS)) {
        param = {
            URL: URL,
        }
    } else {
        param = {
            URL: URL,
            PARAMS: PARAMS,
        }
    }

    const returnFunction = () => {
        if (target) {
            target.focus()
        }
    }

    await tremApi('/public/address/access/output', param)
        .then(obj => {
            let SUCESS = obj.SUCESS
            let MESSAGE = obj.MESSAGE
            let FULL_PATH = obj.FULL_PATH

            if (SUCESS == 'S') {
                let host = window.location.hostname // 웹 호스트의 도메인 네임 반환
                let protocol = window.location.protocol // 사용하는 웹 프로토콜 반환 (http:// 혹은 https://)
                let port = window.location.port // 사용하는 웹 포트 반환 (8080)
                let PATH = ''

                if (host === 'localhost' || host === '127.0.0.1') {
                    PATH = protocol + '//' + host + ':' + port + FULL_PATH
                } else {
                    PATH = protocol + '//' + host + FULL_PATH
                }

                navigator.clipboard.writeText(PATH)

                sys.alert(G.t('trem.lang.home.0935'), null, returnFunction)
                // "주소가 복사 되었습니다. 원하는 곳에 붙여 넣기를 해주세요."
            } else {
                sys.alert(MESSAGE, null, returnFunction)
            }
        })
        .catch(err => {
            sys.alert(err, G.t('trem.lang.home.0836'), returnFunction) /* 오류발생 */
        })
}


const goHelp = URL => {
    if (!R.isNil(URL)) {
        const currentLang = Cookies.get('__floor_lang__') || 'ko'
        URL += '?lang=' + currentLang
        window.open(
            `${serverUrl}${serverPrefixUrl}` + URL,
            '_black',
            'width=800, height=550, scrollbars=yes, resizable=no, left=0, top=0'
        )
    }
}
const getProperity = () => {
    const properties = tremApi('/r/master/get/properties').then(obj => {
        return obj
    })

    return properties
}

const setAccessPageHistory = async moveUrl => {    
    const properties = await tremApi('/r/master/get/properties')

    if (!properties) {
        alert(G.t('trem.lang.home.1117')) /* 오류발생(프로퍼티) */
        return false
    }

    if (S.isLogin() && properties.sshSsessionInfo === 'Y') {
        let href = window.location.href // 현재 페이지의 href (URL) 반환
        let host = window.location.hostname // 웹 호스트의 도메인 네임 반환
        let protocol = window.location.protocol // 사용하는 웹 프로토콜 반환 (http:// 혹은 https://)
        let port = window.location.port // 사용하는 웹 포트 반환 (8080)

        let FULL_PATH = ''

        if (host === 'localhost' || host === '127.0.0.1') {
            FULL_PATH = protocol + '//' + host + ':' + port + moveUrl
        } else {
            FULL_PATH = protocol + '//' + host + moveUrl
        }

        let CURRENT_PAGE = window.location.pathname

        let param = {
            FULL_PATH: FULL_PATH,
            PAGE: moveUrl,
            BF_PAGE: CURRENT_PAGE,
        }

        tremApi('/session/info/move/access/page/json', param)
    }
}

const getPhotoURL = (photoSkey) => {

    let photoURL = `${serverUrl}${serverPrefixUrl}`

    if(R.isNil(photoSkey)){
        photoURL += "/resources/images/gist/common/no_image.jpg"
    }else{
        photoURL += "/attach/download?FILE_SKEY="+ photoSkey
    }

    return photoURL
}

export default { getNewPublicAddress, getPublicAddress, goHelp, setAccessPageHistory, getProperity, getPhotoURL }
